import { SET_WORKSPACE_SETTINGS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_WORKSPACE_SETTINGS_SETTINGS, {
  isDeletingWorkspace: false,
  isChangingCreditCard: false,
  mtuCount: 10000,
  isChangingSubscription: false,
  transactionFailed: false,
  isRemoveDomainDialogVisible: false,
  deleteError: null
})
